import { render, staticRenderFns } from "./CategoryCardBasicData.vue?vue&type=template&id=21bf7032&scoped=true"
import script from "./CategoryCardBasicData.vue?vue&type=script&lang=ts"
export * from "./CategoryCardBasicData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf7032",
  null
  
)

export default component.exports